import React, { Component } from 'react';
import { TableData } from './TableData';
import { ApplyFilter } from './SearchOptions';

export class MarketDirection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      market_direction_columns: [],
      market_direction_data: [[]],
      search_options: {}
    };

    this.setSearchOptions = function(new_search_options) {
      this.setState({search_options: new_search_options})
    }.bind(this);
  }

  modifyData = function(value) {
    if(value.toString() === "true") {
      return  <th style={{background: "green"}}>True</th>
    } else if(value.toString() === "false") {
      return <th style={{background: "red"}}>False</th>
    } else {
      return <th>{value.toString()}</th>
    }
  }

  componentDidMount() {
    this.setState({ isLoading: true });
 
    fetch("http://Apiprod2-env.eba-44zy3tfi.us-east-2.elasticbeanstalk.com/api/market_direction")
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(res => this.setState({ date: res.date_string, market_direction: res.market_direction, market_direction_columns: res.market_direction_columns, market_direction_data: res.market_direction_data}))
      .catch(error => this.setState({ error }));
  }



  render() {

    var market_direction_summary_background = "yellow"
    if(this.state.market_direction === "Upward") {
      market_direction_summary_background = "green"
    } else if(this.state.market_direction === "Downward") {
      market_direction_summary_background = "red"
    }

    return <div className="MarketDirectionComp">
        <h1 style={{background: market_direction_summary_background}}> Market Direction: {this.state.market_direction} </h1>
        <div className="MarketDirection">
        <h1 style={{background: market_direction_summary_background}}> Market Direction: {this.state.market_direction} </h1>
          <div className="MarketDirectionData">
              <TableData modifyData={this.modifyData} columns={this.state.market_direction_columns} notifyRule={this.props.notifyRule} data={this.state.market_direction_data.filter((data_row) => ApplyFilter(this.state.market_direction_columns, data_row, this.state.search_options))}/>
          </div>
        </div>
{/* 
        <form action="http://lwowski-stock-screener.us-east-2.elasticbeanstalk.com/export_table" method="get">
              <input type="submit" value="Download Table"/>
        </form>
        <SearchOptions option_names={this.state.market_direction_columns}
                      data_types={this.state.market_direction_data[0].map(value => typeof(value))}
                      set_search_options={this.setSearchOptions}/> */}
    </div>
  }
}